import type { AppMode } from '@iheartjane/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

import {
  getTargetedBrandSpecials,
  targetedBrandSpecialsKeys,
} from '@jane/shared/data-access';

interface TargetedBrandSpecialsQueryProps {
  appMode: AppMode;
  page?: number;
  perPage?: number;
  storeIds: (string | number)[];
}

const getTargetedBrandSpecialsQueryOptions = ({
  appMode,
  storeIds,
  page,
  perPage,
}: TargetedBrandSpecialsQueryProps) =>
  queryOptions({
    enabled: !!storeIds.length && !!appMode,
    queryFn: () =>
      getTargetedBrandSpecials({ appMode, storeIds, page, perPage }),
    queryKey: targetedBrandSpecialsKeys.brandSpecials({
      appMode,
      storeIds,
      page,
      perPage,
    }),
  });

export const useTargetedBrandSpecialsForStore = (
  storeId: string | number,
  { enabled }: { enabled: boolean }
) => {
  const options = getTargetedBrandSpecialsQueryOptions({
    appMode: 'kiosk',
    storeIds: [storeId],
  });
  return useQuery({
    ...options,
    enabled: enabled && options.enabled,
  });
};
